import { useEffect } from 'react';

/**
 * Dispatches a window resize event after Formio renders,
 * so it can properly measure its container dimensions
 * (needed inside accordions/modals with overflow: hidden).
 */
function useFormioResize(trigger: unknown) {
  useEffect(() => {
    if (trigger) {
      const timer = setTimeout(() => {
        window.dispatchEvent(new Event('resize'));
      }, 50);
      return () => clearTimeout(timer);
    }
  }, [trigger]);
}

export default useFormioResize;
